import React from "react";
import { QRCode } from '../qrcode'
import PointBase from "./Base/PointBase";
import { pointOptions} from "./ultil";


/**
 * @QrProvider(
 *   id = "star_2",
 *   title = @Translation("Star 2")
 * )
 */
export default class RendererStar2 extends PointBase {

	/**
	 * constructor
	 * @param $options
	 * @param $qrcode
	 * @param $name
	 */
	constructor($options: any = {}, $qrcode: QRCode, $name?: string) {
		const pointRender = ($options: any) => {
			let $opts = pointOptions($options, ['transform', 'fill'], [], function ($opts: any){
				let { x, y, scale } = $opts || {};
				return Object.assign($opts, { "transform": `translate(${x},${y}) scale(${scale})` });
			});
			return (<path {...$opts} d="M54.7731 2.61045L64.8092 24.3552C68.1545 27.7005 69.8272 29.3732 73.1725 29.3732L96.5899 32.7185C99.9353 32.7185 101.608 37.7365 99.9353 41.0819L83.2086 57.8086C79.8632 59.4813 79.8632 62.8266 79.8632 66.172L84.8812 89.5894C84.8812 92.9347 81.5359 96.28 78.1905 94.6074L56.4458 84.5713C53.1005 82.8987 49.7551 82.8987 46.4098 84.5713L24.6651 94.6074C21.3197 96.28 17.9744 94.6074 17.9744 89.5894L21.3197 66.172C21.3197 62.8266 21.3197 59.4813 17.9744 57.8086L1.24766 41.0819C-0.425013 37.7365 1.24766 34.3912 4.593 32.7185L28.0104 29.3732C31.3557 29.3732 34.7011 26.0278 36.3738 24.3552L46.4098 2.61045C49.7551 -0.734895 53.1005 -0.734895 54.7731 2.61045Z"/>);
		}

		Object.assign($options, {"pos": pointRender })

		super($options, $qrcode, $name || 'RendererStar2');
	}
}
